<template>
  <div
    class="history-wrapper flex-a-c"
    :style="{
      width: isMobile ? '100%' : `calc(100% - ${this.isCollapsed ? 80 : 210}px)`
    }"
    @wheel.prevent="handleScroll"
    ref="scrollWrap"
  >
    <div
      class="history-item "
      v-for="(tag, index) of historyTags"
      :key="tag.name"
    >
      <a-dropdown :trigger="['contextmenu']">
        <a-tag
          class="pointer not-select"
          :closable="index === 0 ? false : true"
          @close="handleClose(index)"
          @click.native="handleClick(tag)"
          :color="$route.name === tag.name ? primaryColor : ''"
        >
          {{ tag.meta.title }}
        </a-tag>

        <a-menu slot="overlay" @click="onMenuClick(index, tag, $event)">
          <a-menu-item key="refresh">
            刷新
          </a-menu-item>
          <a-menu-item key="close" v-if="index !== 0">
            关闭
          </a-menu-item>
          <a-menu-item key="closeOther">
            关闭其它
          </a-menu-item>
          <a-menu-item key="closeAll">
            关闭所有
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["isCollapsed", "isMobile", "historyTags", "primaryColor"])
  },
  methods: {
    ...mapActions({
      rmoveHistoryTag: "rmoveHistoryTag",
      removeOtherTag: "removeOtherTag",
      removeAllTag: "removeAllTag"
    }),
    handleClose(index) {
      if (this.historyTags[index].name === this.$route.name) {
        if (this.historyTags.length === index + 1) {
          this.$router.push({
            name: "Redirect",
            params: { route: this.historyTags[index - 1] }
          });
        } else {
          this.$router.push({
            name: "Redirect",
            params: { route: this.historyTags[index + 1] }
          });
        }
      }
      this.rmoveHistoryTag(index);
    },
    handleClick(tag) {
      if (this.$route.name !== tag.name) {
        this.$router.push({ name: "Redirect", params: { route: tag } });
      }
    },
    onMenuClick(index, tag, e) {
      switch (e.key) {
        case "refresh":
          this.$router.replace({
            name: "Redirect",
            params: { route: tag }
          });
          break;
        case "close":
          this.handleClose(index);
          break;
        case "closeOther":
          this.$router.push({
            name: "Redirect",
            params: { route: this.historyTags[index] }
          });
          this.removeOtherTag(index);
          break;
        case "closeAll":
          this.$router.push({
            name: "Redirect",
            params: { route: this.historyTags[0] }
          });
          this.removeAllTag();
          break;
      }
    },
    handleScroll(e) {
      const delta = e.wheelDelta;
      this.$refs.scrollWrap.scrollLeft =
        this.$refs.scrollWrap.scrollLeft + delta / 4;
    }
  }
};
</script>
<style lang="less" scoped>
.history-wrapper {
  height: 44px;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.32);
  position: fixed;
  top: 64px;
  right: 0;
  width: 100%;
  z-index: 999;
  flex-shrink: 0;
  transition: all 0.2s;
  padding: 0 24px;
  overflow-x: auto;
  // 覆盖默认的滚动条
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 4px;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: hsla(0, 0%, 53%, 0.4);
  }

  &:hover::-webkit-scrollbar-track {
    background: hsla(0, 0%, 53%, 0.1);
  }
}
</style>
